import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {convertAmount} from '../../../../core/ult-functions/currency-calculation';
import {getConditionBadge} from '../../../../core/ult-functions/condition-badge';
import {SETTINGS} from '../../../../core/config/common.settings';

@Component({
  selector: 'app-view-experiences-content',
  templateUrl: './view-experiences-content.component.html',
  styleUrls: ['./view-experiences-content.component.scss']
})
export class ViewExperiencesContentComponent implements OnInit {
  @Input() itinerary?: any;
  @Input() experience?: any;

  selectedExperiences: any = [];
  totalCost = 0;
  currency?: string;
  secondaryCurrency?: string;
  exchangeRate = 0;
  isPrimaryCurrency = true ;
  pax:any;
  conditionTypes: any[] = [];

  constructor(
    private translocoService: TranslocoService
  ) {
  }

  ngOnInit(): void {
    this.conditionTypes = this.getConditionTypeOptions();

    if (!this.itinerary.tour.isDatesOptional) {
      this.selectedExperiences = this.itinerary.experiences
        .filter((tempDay: any) =>
          tempDay.experiencesPerDay.some(
            (expPerDay: any) => expPerDay?.experience?._id === this.experience?.experience?._id
          )
        )
        .map((tempDay: any) => tempDay.date);
    } else {
      this.selectedExperiences = this.itinerary.experiences
        .map((tempDay: any, index: number) =>
          tempDay.experiencesPerDay.some(
            (expPerDay: any) =>
              expPerDay?.experience?._id === this.experience?.experience?._id
          )
            ? index // keep index if match
            : -1    // mark as not matching
        )
        .filter((i: number) => i !== -1);
    }

    this.totalCost = (this.experience?.costPerAdult * this.itinerary.tour.pax.adults) +
      (this.experience?.costPerChild * this.itinerary.tour.pax.children) +
      (this.experience?.costPerInfant * this.itinerary.tour.pax.infants);

    this.currency = this.itinerary.tour.currency;
    this.secondaryCurrency = this.itinerary.tour?.secondaryCurrency ?? '';
    this.exchangeRate = this.itinerary.tour?.exchangeRate ?? 0;
    this.isPrimaryCurrency = this.experience?.isPrimaryCurrency ?? true;
    this.pax = this.itinerary.tour.pax;

  }

  displayTitle(titles: any, defaultLanguage: string): string {
    return titles
      .filter((item: any) => item.language === defaultLanguage)
      .map((item: any) => item.name);
  }

  getMarkupTypeLabel(): string {
    return this.experience.costing?.markupSymbol === SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT
      ? this.translocoService.translate('itineraries.viewContentModal.experiences.percent')
      : this.translocoService.translate('itineraries.viewContentModal.experiences.fixed');
  }

  getSelectedDayLabel(date: any): string {
    return !this.itinerary.tour.isDatesOptional
      ? date
      : this.translocoService.translate('itineraries.viewContentModal.common.dayLabel', { day: date + 1 });
  }

  getEmptyValue(): string {
    return this.translocoService.translate('itineraries.viewContentModal.common.emptyValue');
  }

  getConditionBadge(conditionType: string | null | undefined) {
    return getConditionBadge(conditionType, this.conditionTypes);
  }

  private getConditionTypeOptions(): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = SETTINGS.CONDITION_TYPES.filter(item => (item as any).language === lang);
    return (filtered.length ? filtered : SETTINGS.CONDITION_TYPES.filter(item => (item as any).language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }

  protected readonly convertAmount = convertAmount;
  protected readonly SETTINGS = SETTINGS;
}